import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { CarOutlined, UserOutlined, DollarOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: string,
  url: string,
  icon?: React.ReactNode,
  isHeader?: boolean,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  const menuItem: MenuItem = {
    key: url,
    icon: icon,
    children: children,
    label: !isHeader ? <Link to={url}>{label}</Link> : <>{label}</>,
    type: type,
  };

  return menuItem;
}

const MainMenu: React.FC = () => {
  const items: MenuItem[] = [
    getItem('Vehicles', '/vehicles', <CarOutlined />, true, [
      getItem('New Vehicles', '/vehicles?view=new'),
      getItem('Registered Vehicles', '/vehicles?view=approved'),
      getItem('Auctioned Vehicles', '/vehicles?view=auctioned'),
    ]),
    getItem('Auctions', '/auctions', <DollarOutlined />, true, [
      getItem('Next Auction', '/auctions/next'),
      getItem('Next Auction Users', '/auctions/next/users'),
      getItem('Past Auctions', '/auctions/past'),
      getItem('Live Auction', '/auctions/live'),
    ]),
    getItem('Users', '/users', <UserOutlined />, true, [
      getItem('Admin', '/users/admins'),
      getItem('Sellers', '/users/sellers'),
      getItem('Buyers', '/users/buyers'),
      getItem('Pending Requests', '/users/pending'),
    ]),
    // getItem('Reports', '/report', <PieChartOutlined />, true, [
    //   getItem('Payment Reports', '/reports/payment'),
    // ]),
  ];

  const location = useLocation();
  const url = location?.pathname + location?.search;

  const [current, setCurrent] = useState(url === '/' || url === '' ? '/vehicles?view=new' : url);

  useEffect(() => {
    if (url) {
      if (current !== url) {
        setCurrent(url);
      }
    }
  }, [url, current]);

  return (
    <Menu
      mode='inline'
      items={items}
      defaultOpenKeys={['/vehicles', '/auctions', '/users']}
      // defaultOpenKeys={['/vehicles', '/auctions', '/users', '/reports']}
      defaultSelectedKeys={['/vehicles?view=new']}
      selectedKeys={[current]}
    />
  );
};

export default MainMenu;
